import React, { useState, useMemo } from 'react';
import { Box, Autocomplete, TextField, Button, FormControl, MenuItem, Select, InputLabel } from '@mui/material';
import { useGetList, useListContext } from 'react-admin';
import SearchIcon from '@mui/icons-material/Search';
import { splitTypeOptions } from '../constants';

const ClientSplitRulesFilters = () => {
  const { setFilters } = useListContext();

  const [selectedClient, setSelectedClient] = useState<any>(null);
  const [selectedSplitType, setSelectedSplitType] = useState<string>('');
  const [effectiveDateFrom, setEffectiveDateFrom] = useState('');

  const [inputValue, setInputValue] = useState('');

  const { data: clientChoices = [], isLoading } = useGetList('clients', {
    pagination: { page: 1, perPage: 5000 },
    sort: { field: 'client_name', order: 'ASC' },
  });

  const filteredOptions = useMemo(
    () =>
      clientChoices.filter(
        (c: any) =>
          (c.client_name ?? '').toLowerCase().includes(inputValue.toLowerCase()) ||
          (c.client_number ?? '').toLowerCase().includes(inputValue.toLowerCase())
      ),
    [clientChoices, inputValue]
  );

  const handleApply = () => {
    setFilters({
      client_number: selectedClient?.client_number || undefined,
      split_type: selectedSplitType || undefined,
      effective_date_from: effectiveDateFrom || undefined,
    });
  };

  const handleClear = () => {
    setSelectedClient(null);
    setSelectedSplitType('');
    setEffectiveDateFrom('');
    setInputValue('');
    setFilters({});
  };

  return (
    <Box display="flex" gap={3} px={2} py={1} alignItems="center" flexWrap="wrap">
      <Autocomplete
        options={filteredOptions}
        value={selectedClient}
        onChange={(e, value) => setSelectedClient(value)}
        inputValue={inputValue}
        onInputChange={(e, value) => setInputValue(value)}
        getOptionLabel={(option) => `${option.client_name} (${option.client_number})`}
        isOptionEqualToValue={(opt, val) => opt.client_number === val.client_number}
        loading={isLoading}
        sx={{ width: 350 }}
        renderInput={(params) => <TextField {...params} label="Client Name" variant="standard" size="small" />}
        filterOptions={(x) => x}
      />

      <FormControl variant="standard" size="small" sx={{ width: 200 }}>
        <InputLabel>Split Type</InputLabel>
        <Select value={selectedSplitType} onChange={(e) => setSelectedSplitType(e.target.value)} label="Split Type">
          {splitTypeOptions.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <TextField
        label="Effective Date (From)"
        type="date"
        value={effectiveDateFrom}
        onChange={(e) => setEffectiveDateFrom(e.target.value)}
        InputLabelProps={{ shrink: true }}
        variant="standard"
        size="small"
        sx={{ width: 220 }}
      />
      <Button
        variant="contained"
        startIcon={<SearchIcon />}
        onClick={handleApply}
        sx={{
          minWidth: 100,
          height: 40,
          px: 2,
          borderRadius: 2,
          fontSize: '0.85rem',
          fontWeight: 500,
          textTransform: 'none',
        }}
      >
        Apply
      </Button>

      <Button
        variant="outlined"
        onClick={handleClear}
        sx={{
          minWidth: 100,
          height: 40,
          px: 2,
          borderRadius: 2,
          fontSize: '0.85rem',
          fontWeight: 500,
          textTransform: 'none',
        }}
      >
        Clear
      </Button>
    </Box>
  );
};

export default ClientSplitRulesFilters;
